/**
 * Web auth + API client instances.
 *
 * Same-origin in production (the Worker serves this SPA) and proxied to
 * wrangler dev locally, so the session cookie always travels automatically and
 * no token is ever exposed to JavaScript.
 */
import { createApiClient, createWebAuthClient } from '@ideabrief/core';

export const authClient = createWebAuthClient();

export const api = createApiClient();
